import React, { ReactNode } from 'react';
import styles from './AdminLayout.module.scss';
import { AdminHeader } from '../AdminHeader/AdminHeader';

interface AdminLayoutProps {
    children: ReactNode;
}

export const AdminLayout = ({ children }: AdminLayoutProps) => {
    return (
        <div className={styles.dashboardContainer}>
            <AdminHeader />
            <div className={styles.content}>
                {children}
            </div>
        </div>
    );
};